// @noflow
import React from 'react'
import { useTranslation } from 'react-i18next'

import QuestionMarks from 'assets/images/icons/question_marks.svg'

import Card from '@/components/elements/atoms/Card/Card'
import Text from '@/components/elements/atoms/Text/Text'
import STYLES from '@/components/pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module.sass'

const DidYouKnowCard = (): JSX.Element => {
  const namespace = 'account'
  const { t } = useTranslation('account')

  return (
    <Card border="none" padding={24} variant="brandYellow200">
      <div className={STYLES.didYouKnow}>
        <img
          src={QuestionMarks}
          alt={t('price_sensitive_paused_page.did_you_know.icon_alt')}
          className={STYLES.icon}
          width={91}
          height={39}
        />
        <Text
          namespace={namespace}
          text={`price_sensitive_paused_page.did_you_know.title`}
          variant="display20"
          margin={false}
        />
        <Text
          namespace={namespace}
          text={`price_sensitive_paused_page.did_you_know.body`}
          margin={false}
        />
      </div>
    </Card>
  )
}

export default DidYouKnowCard
